<template>
    <div>
        <template v-if="isUserAuthenticated">
            <div class="mb-4 mt-4">
                <upgrade-token
                    :token="token"
                    :channel="channel">
                </upgrade-token>
            </div>
        </template>

        <connect-wallet
            :channel="channel"
            :signed-in="isUserAuthenticated"
            :route="route"
            @signedIn="checkWalletStatus"
            @signedOut="signedOut"
            style-class="mt-4">
        </connect-wallet>
    </div>
</template>

<script>
import NfTokensMixin from "../Mixins/NfTokensMixin";

export default {
    name: "TokenLayoutComponent",

    props: {
        token: Object,
        sessionChannel: String,
        signedIn: Boolean,
        flashMessage: {
            type: String,
            required: false
        },
        route: String,
    },

    mixins: [NfTokensMixin],

    data() {
        return {
            isUserAuthenticated: this.signedIn ?? false,
            channel: this.sessionChannel ?? '',
        }
    },

    created() {
        if(this.flashMessage) {
            if(this.flashMessage === 'Wallet connected successfully') {
                Toast.fire({
                    icon: 'success',
                    title: this.flashMessage
                })
            } else {
                Toast.fire({
                    icon: 'error',
                    title: this.flashMessage
                })
            }
        }
    }
}
</script>
